var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFalrTrkAct1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.15 6.51001L19.82 9.96001C19.32 10.47 18.55 10.6 17.91 10.28L15.3 8.99001L14.05 10.25L13.47 10.83C13.36 10.94 13.23 11.01 13.1 11.04C13.04 11.06 12.96 11.07 12.89 11.07C12.76 11.07 12.63 11.05 12.52 10.98C12.46 10.94 12.38 10.89 12.33 10.83C12.33 10.83 12.3233 10.8267 12.31 10.82C12.31 10.82 12.28 10.79 12.27 10.77C12.27 10.77 12.21 10.67 12.18 10.64C12.05 10.42 12.03 10.16 12.14 9.92001C12.15 9.89001 12.16 9.86001 12.18 9.82001C12.18 9.81001 12.19 9.81001 12.19 9.80001C12.21 9.78001 12.22 9.75001 12.25 9.71001C12.27 9.69001 12.28 9.66001 12.3 9.64001L12.5 9.45001L13 8.95001L14.14 7.80001C14.64 7.31001 15.41 7.18001 16.03 7.50001L18.64 8.79001L21.95 5.35001C22.27 5.02001 22.8 5.01001 23.14 5.33001C23.46 5.66001 23.47 6.17001 23.15 6.51001Z",
    fill: "url(#paint0_linear_21_231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22998 9.87V9.18V9.76V4.58C7.22998 2.63 8.79998 1.05 10.75 1.04L17.34 1",
    stroke: "url(#paint1_linear_21_231)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.61 20.69H13.42",
    stroke: "url(#paint2_linear_21_231)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.35 11.89C11.94 11.49 11.48 11.12 10.98 10.82C9.89 10.14 8.6 9.76001 7.23 9.76001C3.25 9.76001 0 13.01 0 16.99C0 20.97 3.25 24.22 7.23 24.22C9.86 24.22 12.17 22.8 13.42 20.7C14.09 19.62 14.46 18.35 14.46 16.99C14.46 15 13.65 13.2 12.35 11.89ZM4.97 16.04C4.58 15.65 4.58 15.02 4.97 14.63C5.36 14.24 6 14.24 6.39 14.63L7.23 15.47L8.08 14.63C8.47 14.24 9.1 14.24 9.49 14.63C9.88 15.02 9.88 15.65 9.49 16.04L8.65 16.89L9.7 17.94C10.09 18.33 10.09 18.96 9.7 19.35C9.5 19.55 9.25 19.65 8.99 19.65C8.73 19.65 8.48 19.55 8.28 19.35L7.23 18.3L6.18 19.35C5.98 19.55 5.73 19.65 5.47 19.65C5.21 19.65 4.96 19.55 4.76 19.35C4.37 18.96 4.37 18.33 4.76 17.94L5.82 16.89L4.97 16.04Z",
    fill: "url(#paint3_linear_21_231)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_231",
    x1: 12.07,
    y1: 8.09001,
    x2: 23.39,
    y2: 8.09001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_231",
    x1: 6.22998,
    y1: 5.43,
    x2: 18.34,
    y2: 5.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21_231",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_21_231",
    x1: 0,
    y1: 16.99,
    x2: 14.46,
    y2: 16.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.61,
    height: 24.23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalrTrkAct1);
export default __webpack_public_path__ + "static/media/FalrTrkAct_1.7497b0446329e484705b9b3faacd5af0.svg";
export { ForwardRef as ReactComponent };